const PIXEL_ID = '953724620390529'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

let initialized = false

export function initMetaPixel() {
  if (initialized || typeof window === 'undefined') return
  initialized = true

  try {
    const f = window as any
    const b = document
    const e = 'script'
    const v = 'https://connect.facebook.net/en_US/fbevents.js'

    if (f.fbq) return

    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    f.fbq = n
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = b.createElement(e) as HTMLScriptElement
    t.async = true
    t.src = v
    const s = b.getElementsByTagName(e)[0]
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      b.head.appendChild(t)
    }

    f.fbq('init', PIXEL_ID)
    f.fbq('track', 'PageView')

    console.log('[Meta Pixel] Initialized with ID:', PIXEL_ID)
    console.log('[Meta Pixel] PageView fired')
  } catch (err) {
    console.warn('[Meta Pixel] Failed to initialize:', err)
  }
}

export function trackAddToCart() {
  try {
    if (window.fbq) {
      window.fbq('track', 'AddToCart')
      console.log('[Meta Pixel] AddToCart fired')
    } else {
      console.warn('[Meta Pixel] fbq not available for AddToCart')
    }
  } catch (err) {
    console.warn('[Meta Pixel] Failed to track AddToCart:', err)
  }
}
